import BaseModule from "./BaseModule";

class ResumeModule extends BaseModule {
  constructor() {
    super();
  }
  //搜索简历接口---带筛选
  getResumeList(params) {
    return this.post(`/api/cv/list`, params, {
      headers: {
        "X-HTTP-Method-Override": "GET"
      }
    });
  }
  //获取简历tag
  getDeliverTag() {
    return this.get(`/api/position/types`);
  }
  //简历列表---投递的简历
  getDeliverList(params) {
    return this.post(`/api/cv/deliver`, params, {
      headers: {
        "X-HTTP-Method-Override": "GET"
      }
    });
  }
  //简历列表---下载的简历
  getDownloadList(params) {
    return this.post(`/api/cv/download`, params, {
      headers: {
        "X-HTTP-Method-Override": "GET"
      }
    });
  }
  //简历详情接口
  getResumeDetails(id) {
    return this.get(`/api/cv/${id}`);
  }
  //查看完整简历接口
  getResumeDetailsComplete(id) {
    return this.get(`/api/cv/auth/${id}`);
  }
  //导出在线简历接口
  exportResume(id,log_id) {
    return this.get(`/api/cv/word/${id}?cv_log_id=${log_id}`, {
      responseType: `arraybuffer`
    });
  }
  //下载简历
  downloadResume(id,log_id) {
    return this.get(`/api/cv/download/${id}?cv_log_id=${log_id}`, {
      responseType: "blob"
    });
  }
  //简历详情获取面试邀约企业信息
  getInvited(params) {
    return this.post(`/api/cv/invited/info`, params, {
      headers: {
        "X-HTTP-Method-Override": "GET"
      }
    });
  }
  //简历详情视频邀约
  getSuitable(params) {
    return this.put(`/api/cv/invited`, params);
  }
  //简历控制详情
  deliverStatus(params) {
    return this.post(`/api/cv/deliverstatus`, params, {
      headers: {
        "X-HTTP-Method-Override": "GET"
      }
    });
  }
  //简历详情标记简历状态
  suitableStatus(params) {
    return this.put(`/api/cv/suitable`, params);
  }
  //简历详情收藏简历状态
  getCollectStatus(params) {
    return this.post(`/api/cv/collect/status`, params, {
      headers: {
        "X-HTTP-Method-Override": "GET"
      }
    });
  }
  //简历详情 收藏简历 收藏0r取消
  collectStatus(params) {
    return this.put(`/api/position/cv/collect`, params);
  }
  //简历列表-批量导出
  downloadTask(params) {
    return this.post(`/api/cv/download/task`, params);
  }
}

export default new ResumeModule();



// WEBPACK FOOTER //
// ./src/api/ResumeModule.js